import moment from "moment";

export const extractTimeFromDate = (date) => {
  if (!date) return "";
  return moment(date).format("HH:mm");
};

export const compareFullDateTime = (fromDate, toDate) => {
  if (!fromDate || !toDate) return false;

  const format = "YYYY-MM-DD HH:mm";

  const t1 = moment(fromDate, format, true);
  const t2 = moment(toDate, format, true);

  if (!t1.isValid() || !t2.isValid()) return false;

  return t1.isSameOrBefore(t2);
};

export const convertSeconds = (seconds) => {
  if (seconds == null) return;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const pad = (n) => String(n).padStart(2, "0");

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    remainingSeconds: pad(remainingSeconds),
  };
};
